module.exports = __webpack_public_path__ + "images/wxwork/img-wcwf-2-9009131fbaa7cbfbaf099d498024ebe6.png";